var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartProjectMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fill: "#F4F4F4",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 1.25c5.933 0 10.75 4.817 10.75 10.75s-4.817 10.75-10.75 10.75-10.75-4.817-10.75-10.75 4.817-10.75 10.75-10.75zm4.579 10.041-6.385-3.483c-.25-.136-.554-.131-.799.015-.245.145-.395.409-.395.694v6.966c0 .285.15.549.395.694.245.146.549.151.799.015l6.385-3.483c.26-.142.421-.414.421-.709s-.161-.567-.421-.709z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProjectMenu);
export default __webpack_public_path__ + "static/media/startProjectMenu.1fc25e5940a631823189306b68055799.svg";
export { ForwardRef as ReactComponent };